// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container{
    width: 100%;
    background-color: var(--darkGreen);
    padding: 14px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 10px;
    z-index: 999;
}
.header-container::after,
.header-container::before{
    content: "";
    height: 10px;
    position: absolute;
    top: -10px;
    left: 0;
    right: 0;
    background-color: var(--lightBlack);
}
.header-container::after{
    top: auto;
    bottom: -10px;
}

/* .header-container .left-section{

} */
.header-container .right-section {
    display: flex;
    align-items: center;
    gap: 1rem;
}
.header-container .right-section .MuiBox-root svg {
    color: rgb(255 255 255 / 40%);
}
.header-profile--wrapper .profile-image {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    margin-right: 0.6rem;
}
.header-profile--wrapper .profile-image + span {
    max-width: 140px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.header-profile--wrapper button.h-profile--btn {
    background: transparent;
    padding: 0 1rem 0 0;
    color: rgb(255 255 255/50%);
    font-family: 'Acumin Pro';
    font-size: 16px;
}
.header-profile--wrapper button.h-profile--btn:last-child{
    padding: 0;
}
.header-profile--wrapper button.h-profile--btn .MuiButton-endIcon{
    transition: all 0.4s ease-in-out;
}
.header-profile--wrapper button.h-profile--btn[aria-expanded="true"] .MuiButton-endIcon {
    transform: rotate(180deg);
}
.header-menu .MuiPaper-root {
    background-color: var(--darkGreen);
}
#demo-customized-menu .MuiPaper-root{
    box-shadow: 0 6px 10px rgb(255 255 255/25%); 

}
.header-menu ul .MuiDivider-root{
    border-color: var(--white);
    opacity: 40%;
}
.header-menu ul li{
    color: rgb(255 255 255/40%);
    font-family: 'Acumin Pro';
}
.header-menu ul li svg {
    fill: rgb(255 255 255/40%);
}
.header-container .left-section form.MuiPaper-rounded {
    background-color: var(--darkGreen);
    border-color: var(--whiteLight);
    border-radius: 10px;
}
.notification-box  svg.MuiSvgIcon-root {
    height: auto;
    width: 32px;
}
.search-input {
    display: flex;
    align-items: center;
    width: 350px;
    max-height: 37px;
    background-color: var(--darkGreen);
    border: 1px solid rgb(150, 150, 150);
    color: var(--white);
}
.search-input input.MuiInputBase-input{
    color: var(--white);
}

.toggle-btn-box .MuiSvgIcon-root {
    color: var(--whiteLight);
    font-size: 30px;
    cursor: pointer;
    transition: all 0.4s ease-in-out;
}
.toggle-btn-box .MuiSvgIcon-root:hover{
    color: var(--white);
}

label.label-color {
    color: var(--whiteLight);
    font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/Layouts/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,YAAY;AAChB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,mCAAmC;AACvC;AACA;IACI,SAAS;IACT,aAAa;AACjB;;AAEA;;GAEG;AACH;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kCAAkC;AACtC;AACA;IACI,2CAA2C;;AAE/C;AACA;IACI,0BAA0B;IAC1B,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,oCAAoC;IACpC,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB","sourcesContent":[".header-container{\n    width: 100%;\n    background-color: var(--darkGreen);\n    padding: 14px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: sticky;\n    top: 10px;\n    z-index: 999;\n}\n.header-container::after,\n.header-container::before{\n    content: \"\";\n    height: 10px;\n    position: absolute;\n    top: -10px;\n    left: 0;\n    right: 0;\n    background-color: var(--lightBlack);\n}\n.header-container::after{\n    top: auto;\n    bottom: -10px;\n}\n\n/* .header-container .left-section{\n\n} */\n.header-container .right-section {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n.header-container .right-section .MuiBox-root svg {\n    color: rgb(255 255 255 / 40%);\n}\n.header-profile--wrapper .profile-image {\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    margin-right: 0.6rem;\n}\n.header-profile--wrapper .profile-image + span {\n    max-width: 140px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.header-profile--wrapper button.h-profile--btn {\n    background: transparent;\n    padding: 0 1rem 0 0;\n    color: rgb(255 255 255/50%);\n    font-family: 'Acumin Pro';\n    font-size: 16px;\n}\n.header-profile--wrapper button.h-profile--btn:last-child{\n    padding: 0;\n}\n.header-profile--wrapper button.h-profile--btn .MuiButton-endIcon{\n    transition: all 0.4s ease-in-out;\n}\n.header-profile--wrapper button.h-profile--btn[aria-expanded=\"true\"] .MuiButton-endIcon {\n    transform: rotate(180deg);\n}\n.header-menu .MuiPaper-root {\n    background-color: var(--darkGreen);\n}\n#demo-customized-menu .MuiPaper-root{\n    box-shadow: 0 6px 10px rgb(255 255 255/25%); \n\n}\n.header-menu ul .MuiDivider-root{\n    border-color: var(--white);\n    opacity: 40%;\n}\n.header-menu ul li{\n    color: rgb(255 255 255/40%);\n    font-family: 'Acumin Pro';\n}\n.header-menu ul li svg {\n    fill: rgb(255 255 255/40%);\n}\n.header-container .left-section form.MuiPaper-rounded {\n    background-color: var(--darkGreen);\n    border-color: var(--whiteLight);\n    border-radius: 10px;\n}\n.notification-box  svg.MuiSvgIcon-root {\n    height: auto;\n    width: 32px;\n}\n.search-input {\n    display: flex;\n    align-items: center;\n    width: 350px;\n    max-height: 37px;\n    background-color: var(--darkGreen);\n    border: 1px solid rgb(150, 150, 150);\n    color: var(--white);\n}\n.search-input input.MuiInputBase-input{\n    color: var(--white);\n}\n\n.toggle-btn-box .MuiSvgIcon-root {\n    color: var(--whiteLight);\n    font-size: 30px;\n    cursor: pointer;\n    transition: all 0.4s ease-in-out;\n}\n.toggle-btn-box .MuiSvgIcon-root:hover{\n    color: var(--white);\n}\n\nlabel.label-color {\n    color: var(--whiteLight);\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
